module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/components/project-details/project-details.component.html
// module id = ../../../../../src/app/modules/project-details/components/project-details/project-details.component.html
// module chunks = main